// src/store/main/state.js

// Will contain all the current values for the state of this module

import { DetailStep, MainStep, VorauswahlInteresse } from "@/models/enums";
import { mapDriverLicnceClassesSuper } from "@/models/helper";

let getters = {
  MAINSTEP: (state) => {
    switch (state.currentStep) {
      case DetailStep.VORAUSWAHL_START:
      case DetailStep.VORAUSWAHL_FÜHRERSCHEIN:
      case DetailStep.VORAUSWAHL_FÜHRERSCHEIN_DATEN:
      case DetailStep.VORAUSWAHL_FREIWILLIG:
        return MainStep.VORAUSWAHL;
      case DetailStep.FÜHRERSCHEINKLASSEN:
      case DetailStep.FAHRZEUGTYP:
        return MainStep.FÜHRERSCHEINKLASSEN;
      case DetailStep.TERMIN:
      case DetailStep.TERMIN_LEIHFAHRZEUG:
      case DetailStep.TERMIN_STANDORT:
        return MainStep.TERMIN;
      case DetailStep.PERSÖNLICHEDATEN:
        return MainStep.PERSÖNLICHEDATEN;
      case DetailStep.ÜBERPRÜFEN:
        return MainStep.ÜBERPRÜFEN;
      case DetailStep.DONE:
        return null;
    }
  },
  IS_FÜHRERSCHEIN: (state) => {
    return state.preInterest == VorauswahlInteresse.FÜHRERSCHEIN;
  },
  PI_IS_VALID: (state, getters) => {
    return (
      state.pi.firstname != null &&
      state.pi.firstname != "" &&
      state.pi.lastname != null &&
      state.pi.lastname != "" &&
      state.pi.birthdate != null &&
      state.pi.street != null &&
      state.pi.street != "" &&
      state.pi.housenumber != null &&
      state.pi.housenumber != "" &&
      state.pi.postalcode != null &&
      state.pi.postalcode != "" &&
      state.pi.city != null &&
      state.pi.city != "" &&
      getters.PI_EMAIL_IS_VALID
    );
  },
  PI_EMAIL_IS_VALID: (state) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //console.log(emailPattern.test(state.pi.email));
    return emailPattern.test(state.pi.email);
  },
  NEW_DRIVER_LICENCE_CLASSES_SUPER: (state) => {
    const superClasses = state.newDriverLicenceClasses.map((c) =>
      mapDriverLicnceClassesSuper(c)
    );
    return [...new Set(superClasses)].sort((a, b) => a.localeCompare(b)); // make unqiue and sort alphabetically
  },
  LICENCE_COURSE_PER_CLASS_SELECTED: (state, getters) => {
    const allSuperClasses = getters.NEW_DRIVER_LICENCE_CLASSES_SUPER;
    return allSuperClasses.reduce(
      (acc, c) => acc && state.selectedCourses[c] != null
    );
  },
};

export default getters;
